import axios from 'axios';
import debug from 'debug';

const log = debug('app:GsmpiApiClient');

const gsmpiApi = axios.create({
  timeout: 15000,
});

export const createTransaction = async (createTransactionRequest) => {
  try {
    return await gsmpiApi.post('/gsmpi-api/v1/transactions', createTransactionRequest);
  } catch (error) {
    log(`createTransaction error: ${error}`);
    throw error;
  }
};

export const createTransactionMobileUrl = async (createTransactionRequest) => {
  try {
    const response = await gsmpiApi.post('/gsmpi-api/v1/transactions/mobile-url', createTransactionRequest);
    return response.data;
  } catch (error) {
    log(`createTransactionMobileUrl error: ${error}`);
    throw error;
  }
};

export const bindingAccount = async (transactionId, bindingRequest) => {
  try {
    await gsmpiApi.post(`/gsmpi-api/v1/transactions/${transactionId}/accounts`, bindingRequest);
  } catch (error) {
    log(`bindingAccount error: ${error}`);
    throw error.response.data;
  }
};

export const getTransactionResult = async (transactionId, isMobile, signal) => {
  try {
    return await gsmpiApi.get(`/gsmpi-api/v1/transactions/${transactionId}`, {
      params: {
        isMobile: isMobile
      },
      signal: signal
    });
  } catch (error) {
    log(`getTransactionResult error: ${error}`);
    throw error;
  }
};

export const updateTransactionStatus = async (transactionId, updatePayload) => {
  try {
    const response = await gsmpiApi.post(`/gsmpi-api/v1/payments/${transactionId}/status`, updatePayload);
    return response.data;
  } catch (error) {
    log(`updateTransactionStatus error: ${error}`);
    throw error;
  }
};

export const getPaymentClient = async ({clientId: clientId}) => {
  try {
    return await gsmpiApi.get(`/gsmpi-api/v1/payments/clients/${clientId}`);
  } catch (error) {
    log(`getPaymentClient error: ${error}`);
    throw error;
  }
};

export const getPaymentCredentials = async({refId: refId, serviceId: serviceId}) => {
  try {
    return await gsmpiApi.get(`/gsmpi-api/v1/payments/credentials/${refId}`, {
      params: {
        serviceId: serviceId
      }
    });
  } catch (error) {
    log(`getPaymentCredentials error: ${error}`);
    throw error;
  }
};